import React from "react";
import { twMerge } from "tailwind-merge";
import { useAppContext } from "../../context/AppContext";
import { getPrice } from "../../util/helper";

/** A price with the restaurant's currency symbol, kept left-to-right inside Hebrew text. */
const Price = ({ value, prefix = "", className = "" }) => {
  const { currencySymbol } = useAppContext();
  return (
    <span dir="ltr" className={twMerge("w-fit tabular-nums whitespace-nowrap", className)}>
      {prefix}
      {currencySymbol}
      {getPrice(value)}
    </span>
  );
};

export default Price;
